<script lang="ts">
import Vue, { CreateElement, RenderContext, VNode } from 'vue';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';
import ClientAccessChip from '@/bundles/Contact/components/chips/ClientAccessChip.vue';

interface IProps {
  isClient: boolean;
}

export default Vue.extend({
  name: 'ContactMemberChip',

  functional: true,

  props: {
    // A client-access member only sees the occupiers their contact is granted
    // (SCBT-82) — rendering them as plain "Member" is misleading.
    isClient: Boolean,
  },

  render (h: CreateElement, { props, data }: RenderContext<IProps>): VNode {
    const classes = [data.staticClass, data.class];

    if (props.isClient) {
      return h(ClientAccessChip, { class: classes });
    }

    return h(CommonChip, {
      attrs: { color: 'primary' },
      class: classes,
    }, [
      h('span', 'Member'),
    ]);
  },
});
</script>
